module.exports = __webpack_public_path__ + "static/1-225ab2381b0bb96dc39117538963bbd2.jpg";